import * as React from 'react';

import { toast } from 'react-toastify';

import { Button, Grid, Link, Spacer, Typography } from '@emburse/ui-core';

import { UserProfileApiSvc } from '@ClientApi/userProfile';

import { SignUpWorkflowFooter } from '../SignUpWorkflowFooter';

import * as style from './VerifyEmail.styl';

export const VerifyEmail: React.FC<{}> = () => {
  const supportTicketLink =
    window.whitelabelConfiguration?.supportLinks?.supportTicketLink || 'https://help.spend.emburse.com/hc/en-us/requests/new';
  const userEmail = window.USER.email;
  const resendEmail = async () => {
    try {
      await UserProfileApiSvc.resendVerificationEmail();
      toast.success('Verification Email Resent.');
    } catch (ex) {
      toast.error('Error occurred while sending verification email.');
    }
  };
  return (
    <Grid
      container
      alignItems="center"
      wrap="nowrap"
      justifyContent="space-between"
      direction="column"
      className={style.global}
      style={{ height: '100%', paddingTop: 120 }}
    >
      <Grid container direction="column" style={{ maxWidth: '754px' }}>
        <Grid item>
          <Typography variant="h4">Verify your email to continue</Typography>
          <Spacer size={24} />
          <Typography variant="body1">We just sent a verification email to {userEmail}.</Typography>
          <Typography>
            Wrong email address?{' '}
            <Link href={supportTicketLink} target="_blank" rel="noopener">
              Please submit a ticket
            </Link>{' '}
            to our Support team
          </Typography>
          <Spacer size={24} />
          <Button
            variant="contained"
            color="primary"
            onClick={resendEmail}
            className="signup-resend-verification"
            aria-label="signup-resend-verification"
          >
            Resend Verification
          </Button>
        </Grid>
      </Grid>
      <Grid container alignContent="flex-end">
        <SignUpWorkflowFooter showSupportLink={true} ariaLabel="verification" />
      </Grid>
    </Grid>
  );
};
